import axios from "axios";
import { SERVERTAPI } from "@/config/index";
import { Toast } from 'vant';
import router from "@/router";
import Router from "@/router";

const instance = axios.create({
    baseURL: process.env.NODE_ENV == 'development' ? '/api' : SERVERTAPI.replace(/\/+$/, ""),
    // baseURL: SERVERTAPI.replace(/\/+$/, ""),
    // baseURL: "https://api.netfiixstv.cyou",
    timeout: 20000,
    headers: {}
});
console.log(process.env.NODE_ENV == 'development' ? '/api' : SERVERTAPI.replace(/\/+$/, ""),);

instance.interceptors.request.use(function (config) {
    // console.log(config);

    // 在发送请求之前显示loading

    // config.config.isLoading && (loadingInstance = Loading.service({
    //   lock: true,
    //   text: '加载中',
    //   spinner: 'el-icon-loading',
    //   background: 'rgba(0, 0, 0, 0.5)'
    // }));
    // 判断token为空
    const { name: currentRouteName } = router.currentRoute;
    if (!['login', 'register', 'lang', 'serve'].includes(currentRouteName)) {
        if (localStorage.getItem('token') === null) {
            router.push('/login');
        }
    }
    // 在请求头中添加token和device_token
    const token = localStorage.getItem('token');
    if (token) {
        config.headers['token'] = token;
    } else {
        delete config.headers['token'];
    }
    if (config.config.formData) {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
    config.device_token = "";
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
    console.log(response);

    // 对响应数据做点什么
    const { status, data } = response;
    const { name: currentRouteName } = router.currentRoute;
    if (status === 200) {
        console.log(currentRouteName)
        if (data.code === -1) {
            if (currentRouteName !== 'register' && currentRouteName !== 'serve' && currentRouteName !== 'lang') {
                Toast.fail('Please login again');
                setTimeout(() => {
                    localStorage.removeItem('userString');
                    localStorage.removeItem('uid');
                    localStorage.removeItem('userInfo');
                    localStorage.removeItem('token');
                    Router.push({ path: '/Login' });
                }, 1000)
            }
        }
        switch (data.status) {
            case 400:
                // Router.push({path: '/Login'})
                break;
        }
        return Promise.resolve(data);
    } else {
        if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
            // 处理超时请求提示
            Toast.fail('Request timed out');
        } else {
            Toast.fail(error);
        }
        Toast.fail(data.mess);
        // return Promise.reject(response);
    }
}, error => {
    // 对响应错误做点什么
    // 隐藏loading
    // loadingInstance.close();
    // return Promise.reject(error);
    Toast.fail('server error');
    return error;
});


export default instance;
